const USER_CREATION_AND_ASSIGNMENT_SLUGS = new Set([ 'admin', 'developer', 'mp_control', 'tl' ]);
const PRIVILEGED_GROUP_SLUGS = new Set([ 'admin', 'developer' ]);

const normalizeRoleSlug = (role) => typeof role?.slug === 'string' ? role.slug.trim().toLowerCase() : '';


export const canCreateUsers = (me) => {

    return USER_CREATION_AND_ASSIGNMENT_SLUGS.has(normalizeRoleSlug(me?.role));
};


export const canAssignUserGroups = (me) => {

    return USER_CREATION_AND_ASSIGNMENT_SLUGS.has(normalizeRoleSlug(me?.role));
};


export const isAssignableUserRole = (role, canManageUserGroups = false) => {

    const roleSlug = normalizeRoleSlug(role);

    return canManageUserGroups || (!!roleSlug && !PRIVILEGED_GROUP_SLUGS.has(roleSlug));
};
